export const EditFileCategoryModal: string = 'EditFileCategoryModal';
